import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { HashRouter as Router } from "react-router-dom";
import { GAProvider } from "@connectaryal/google-analytics";

/* global document, module, require */

const rootElement = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

root?.render(
  <GAProvider config={{ measurementId: "NONE" }}>
    <Router>
      <App />
    </Router>
  </GAProvider>
);

if (module.hot) {
  module.hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
